import { recordSubscriptionSale } from '../../services/receptionist/receptionistApi';
import { subscriptionDurationLabel } from './sales/saleDurationUtils';
import {
  isWalkInMemberName,
  WALK_IN_PAYMENT_NAME,
} from '../../services/receptionist/walkInMember';

const UPDATE_EVENT = 'receptionist-payments-updated';

export function notifyPaymentsUpdated() {
  window.dispatchEvent(new CustomEvent(UPDATE_EVENT));
}

export const PAYMENTS_UPDATE_EVENT = UPDATE_EVENT;

export async function addSubscriptionPayment({
  paymentId,
  invoiceId,
  customer,
  package: packageName,
  paymentAmount,
  paymentType,
  paymentSplits = [],
  paymentStatus = 'completed',
  paymentNote,
  date,
  packagePrice,
  discountPercent,
  discountAmount,
  registrationFee,
  personalTraining,
  classesFee,
  expiryDate,
  startDate,
  datesTbc = false,
  gymMemberId = '',
  memberId = '',
  duration = '',
  durationMonths = null,
  complimentary = false,
  branch = '',
}) {
  const durationLabel = datesTbc
    ? (String(duration || '').trim() || subscriptionDurationLabel(durationMonths) || '')
    : (String(duration || '').trim()
      || subscriptionDurationLabel(durationMonths)
      || '');

  const paymentCustomer = isWalkInMemberName(customer) ? WALK_IN_PAYMENT_NAME : customer;
  // Blank start (and not TBC) → entry/payment date, never leave null
  const resolvedStart = datesTbc
    ? null
    : (String(startDate || date || '').slice(0, 10) || null);

  const record = await recordSubscriptionSale({
    customerName: paymentCustomer,
    packageName,
    expiryDate: datesTbc ? null : expiryDate,
    startDate: resolvedStart,
    datesTbc,
    gymMemberId,
    memberId,
    duration: durationLabel,
    complimentary,
    payment: complimentary
      ? null
      : {
        id: paymentId,
        invoiceId,
        member: paymentCustomer,
        package: packageName,
        amount: Number(paymentAmount) || 0,
        method: paymentType,
        date,
        status: paymentStatus,
        paymentNote: paymentNote || '',
        source: 'subscription',
        packagePrice: packagePrice || 0,
        discountPercent: discountPercent || 0,
        discountAmount: discountAmount || 0,
        registrationFee: registrationFee || 0,
        personalTraining: personalTraining || 0,
        classesFee: classesFee || 0,
        paymentSplits,
        duration: durationLabel,
        branch,
      },
    branch,
  });

  notifyPaymentsUpdated();
  return record;
}
